<template>
    <div class="userBox bg_white">
        <div class="header">
            <div class="filter">
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">手机号：</span>
                    <input type="text" @blur="phoneChange" />
                </div>
            </div>
        </div>
        <lists class="bg_white" ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData"
               @frozenEvent="frozenEvent" @statusEvent="statusEvent" @enableEvent="enableEvent"></lists>

        <status-detail ref="statusDetail" @updateData="$refs.lists.updateData()"></status-detail>
    </div>
</template>

<script>
    import Lists from '@/components/Lists'
    import statusDetail from './statusDetail'
    export default {
        name: "user",
        components: {
            Lists,statusDetail
        },
        data() {
            return {
                lists: {
                    title: [{text: '基本信息'}, {text: 'openid'}, {text: '电话'}, {text: '性别'}, {text: '省市'}, {text: '状态'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '20%', textAlign: 'left'},
                    {width: '25%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                    {width: '10%', textAlign: 'center'},
                    {width: '15%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left', event: 'statusEvent'},
                    {width: '10%', textAlign: 'left'},
                ],
                httpRequestData: {
                    url: '/manage/user',
                    func: this.httpRequestHandle,
                    error: '获取用户信息出错',
                    auto: true
                },
            }
        },
        created() {

        },
        methods:{
            httpRequestHandle(data) {
                return data.map(item =>{
                    let sex = item.sex === 1 ? '男' : '女';
                    let address = item.province + '·' + item.city + '';
                    let operation = {
                        arr: [
                            {text: '冻结', style: {color: '#FF2118'}, event: 'frozenEvent'},
                            {text: '启用', style: {color: '#1890FF'}, event: 'enableEvent'},
                        ]
                    };
                    return [
                        {text: item.name, img: {img_src: item.header, style: {width: '34px',height: '34px',marginRight: '6px',verticalAlign: 'middle'}}},
                        {text: item.openid},
                        {text: item.tel},
                        {text: sex},
                        {text: address},
                        {text: this.$config.userStatus.get(item.status)},
                        operation
                    ]
                });
            },
            statusEvent(data) {
                if(data.status === 0){
                    this.$modal({content: data.status_detail});
                }
            },
            frozenEvent(data) {
                this.$refs.statusDetail.init(data.id);
            },
            phoneChange(event) {
                let data = event.target.value;
                let filter = !data ? {} : {phone: data};
                this.$refs.lists.updateData(filter);
            },
            enableEvent(data) {
                this.$api.put('/manage/user_status/' + data.id,{
                    status: 1,
                    status_detail: ''
                }).then((data) => {
                    this.$alert.success({content: '启用成功'});
                    this.$refs.lists.updateData();
                }).catch((error) => {
                    this.$alert.error({content: '启用失败，请重试'});
                });
            }
        }
    }
</script>

<style scoped>
    .userBox{
        min-width: 1400px !important;
        padding: 0 5px;
    }
    .userBox>.header{
        height: 80px;
    }
    .filter>div{
        height: 36px;
        line-height: 36px;
        margin: 22px 0 0 20px;
    }
    .filter>div>input{
        width: 220px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
        height: 34px;
        line-height: 34px;
    }
    .filter>div>.select{
        width: 220px;
        border-radius: 3px;
        height: 36px;
        line-height: 36px;
    }
</style>